import React from 'react';
import { DisplayInputComponentProps } from '../../types';
import type { FieldValues } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { Network } from 'jamespot-front-business';
import { WidgetAudience } from 'jamespot-user-api';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { useAppSelector } from '../../../redux/store';

export const InputAudience = <TFieldValues extends FieldValues>(props: DisplayInputComponentProps<TFieldValues>) => {
    const intl = useIntl();
    const networkPublic = useAppSelector(Network.selectors.selectNetworkPublic);
    const JRCInputAudience = commonComponentsRegistry.getLazyComponent('InputAudience');
    return (
        <JRCInputAudience
            dataCy="audience-input"
            label={intl.formatMessage({ id: 'GLOBAL_Audience' })}
            name={props.name}
            control={props.control}
            multiple
            searchable
            placeholder={intl.formatMessage({ id: 'GLOBAL_Audience' })}
            defaultCustomOptions={
                networkPublic && !(props.widget as WidgetAudience).options?.disableEveryoneAudience
                    ? [
                          {
                              uri: networkPublic.uri,
                              title: networkPublic.title,
                              resetOptions: true,
                              icon: 'icon-fs-wall',
                          },
                      ]
                    : []
            }
        />
    );
};
